import { render } from "./eventMainPage.vue?vue&type=template&id=16b44c66&scoped=true"
import script from "./eventMainPage.vue?vue&type=script&lang=js"
export * from "./eventMainPage.vue?vue&type=script&lang=js"

import "./eventMainPage.vue?vue&type=style&index=0&id=16b44c66&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b44c66"]])

export default __exports__